const state = {
  allBeneficiaries: [],
  oneBeneficiarie: null,
  currentBeneficiarie: {},
  all: []
}
export default state
